import axios from 'axios';
import {
  ScoutEmailSettings,
  UpdateScoutEmailSettingsRequest,
  ScoutEmailSettingsResponse,
  UpdateScoutEmailSettingsResponse,
} from '../types/scout-settings';

class ScoutSettingsService {
  /**
   * 現在のスカウトメール受信設定を取得
   */
  async getScoutEmailSettings(): Promise<ScoutEmailSettings> {
    try {
      const response = await axios.get<ScoutEmailSettingsResponse>(
        '/api/users/me/scout-settings',
        { withCredentials: true }
      );

      return {
        acceptsScoutEmails: response.data.data.accepts_scout_emails,
      };
    } catch (error) {
      console.error('Failed to get scout email settings:', error);

      if (axios.isAxiosError(error)) {
        if (error.response?.data?.error?.message) {
          throw new Error(error.response.data.error.message);
        }

        // HTTPステータスコードに基づくエラーメッセージ
        switch (error.response?.status) {
          case 403:
            throw new Error('この機能は学生のみ利用できます');
          case 401:
            throw new Error('認証が必要です。ログインしてください');
          case 500:
            throw new Error('サーバーエラーが発生しました');
          default:
            throw new Error(
              `API エラー: ${error.response?.status || 'unknown'}`
            );
        }
      }

      throw new Error('スカウト設定の取得に失敗しました');
    }
  }

  /**
   * スカウトメール受信設定を更新
   */
  async updateScoutEmailSettings(
    settings: UpdateScoutEmailSettingsRequest
  ): Promise<{ acceptsScoutEmails: boolean; message: string }> {
    try {
      const response = await axios.put<UpdateScoutEmailSettingsResponse>(
        '/api/users/me/scout-settings',
        {
          accepts_scout_emails: settings.acceptsScoutEmails,
          confirmation_acknowledged: settings.confirmationAcknowledged,
        },
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return {
        acceptsScoutEmails: response.data.data.accepts_scout_emails,
        message: response.data.data.message,
      };
    } catch (error) {
      console.error('Failed to update scout email settings:', error);

      if (axios.isAxiosError(error) && error.response?.data?.error?.message) {
        throw new Error(error.response.data.error.message);
      }

      throw new Error('スカウト設定の更新に失敗しました');
    }
  }
}

export const scoutSettingsService = new ScoutSettingsService();
